import React from 'react';
import { ScrollableTextBlocksWithBackgroundImagesType } from '@appTypes/ScrollableTextBlocksWithBackgroundImagesType';
import { ScrollableTextBlocksWithBackgroundImages } from '@components/SectionBlocks/blocks/Parallax/ScrollableTextBlocksWithBackgroundImages';

interface ParallaxProps {
  value: ScrollableTextBlocksWithBackgroundImagesType;
}

export const ParallaxBlock = ({ value }: ParallaxProps) => <ScrollableTextBlocksWithBackgroundImages block={value} />;
